export default __webpack_public_path__ + "static/media/hotel-room.41972306.png";